// CMS entries for dfsweb-rewamp-common override these at runtime.
export const en = {
  "LOCATION_FILTER.ARIA": "Filter by location",
  "LOCATION_FILTER.DISTRICT": "District",
  "LOCATION_FILTER.BLOCK": "Block",
  "LOCATION_FILTER.PANCHAYAT": "Panchayat",
  "LOCATION_FILTER.SELECT": "Select",
  "LOCATION_FILTER.SELECT_DISTRICT": "Select District",
  "LOCATION_FILTER.SELECT_BLOCK": "Select Block",
  "LOCATION_FILTER.SELECT_PANCHAYAT": "Select Panchayat",
  "LOCATION_FILTER.ALL": "All",
  "LOCATION_FILTER.NO_OPTIONS": "No options",
  "FILTER_ROW.SORT_BY": "Sort By",
  "FILTER_ROW.CATEGORY": "Categories",
  "FILTER_ROW.MIN": "Min",
  "FILTER_ROW.MAX": "Max",
  "FILTER_ROW.DATE_FROM": "From date",
  "FILTER_ROW.DATE_TO": "To date",
  "FILTER_ROW.FROM": "From",
  "FILTER_ROW.TO": "To",
  "FILTER_ROW.DATE_CLEAR": "Clear dates",
  "FILTER_ROW.CLEAR_ALL": "Clear all",
  "FILTER_ROW.CLEAR_FIELD": "Clear {{label}}",
  "FILTER_ROW.REQUIRED_TO_APPLY": "Select {{label}} to apply filter",
  "FILTER_ROW.DATE_BOTH_REQUIRED": "Select both dates to apply",
  "ACTION_CONFIRM_DIALOG.CANCEL": "Cancel",
  "ACTION_CONFIRM_DIALOG.CONFIRM": "Yes, Continue",
  "DBT_REQUIRED_DIALOG.TITLE": "To avail the benefits sync your DBT ID.",
  "DBT_REQUIRED_DIALOG.CONFIRM": "Input DBT ID",
  "LANGUAGE_MENU.LABEL": "Language",
  "GLOBAL_SEARCH.PLACEHOLDER_ANYTHING": "Search Anything…",
  "GLOBAL_SEARCH.VOICE_START": "Start voice search",
  "GLOBAL_SEARCH.VOICE_STOP": "Stop voice search",
  "GLOBAL_SEARCH.VOICE_PERMISSION": "Microphone access is blocked. Allow it from the site settings (lock icon in the address bar) and try again.",
  "GLOBAL_SEARCH.VOICE_NO_DEVICE": "No microphone found. Connect a microphone and try again.",
  "GLOBAL_SEARCH.VOICE_BUSY": "The microphone is being used by another app. Close it and try again.",
  "GLOBAL_SEARCH.VOICE_NO_SPEECH": "Failed to detect speech",
  "GLOBAL_SEARCH.VOICE_FAILED": "Failed to analyze your voice",
  "PWA_BOTTOM_BAR.HOME": "Home",
  "PWA_BOTTOM_BAR.HELP": "Help & Support",
  "PWA_BOTTOM_BAR.SERVICES": "All Services",
  "PWA_BOTTOM_BAR.CHAT": "Chat with Bihar Krishi AI",
  "PWA_BOTTOM_BAR.LABEL": "App navigation",
  "GLOBAL_SEARCH.VOICE_PROCESSING": "Processing voice search",
  "PWA_APPBAR.WELCOME_PLAIN": "Welcome",
  "PWA_APPBAR.PROFILE_MENU": "Profile menu",
  "PWA_ACCOUNT_DRAWER.CLOSE_ARIA": "Close account menu",
  "PWA_ACCOUNT_DRAWER.NAME_FALLBACK": "Farmer",
  "PWA_ACCOUNT_DRAWER.VIEW_PROFILE": "View Profile",
  "PWA_ACCOUNT_DRAWER.MOBILE_LABEL": "Mobile Number:",
  "PWA_ACCOUNT_DRAWER.LOGOUT": "Logout",
  "PWA_ACCOUNT_DRAWER.SHARE_TITLE": "Share Bihar Krishi",
  "PWA_ACCOUNT_DRAWER.SHARE_BODY":
    "Share the Bihar Krishi mobile application link with farmers, friends, and family so they can download it from the Play Store.",
  "PWA_ACCOUNT_DRAWER.SHARE_LINK": "Share Link",
  "PWA_LANGUAGE.TITLE": "Choose your language",
  "PWA_LANGUAGE.GROUP_LABEL": "Language",
  "PWA_LANGUAGE.NOTE_LABEL": "NOTE :",
  "PWA_LANGUAGE.NOTE": "You can change the language anytime from the top bar.",
  "PWA_LOGIN.PAGE_TITLE": "Log In",
  "PWA_APP_LOADER.TITLE": "Krishi Sahayak",
  "PWA_HOME.QUICK_TABS_LABEL": "Quick services",
  "PWA_HOME.TAB_AGENT_SERVICE": "Agent Service",
  "PWA_HOME.TAB_ADVISORIES": "Advisories",
  "PWA_HOME.TAB_ASSETS": "Assets",
  "PWA_HOME.TAB_IMPORTANT_SERVICES": "Important Services",
  "PWA_HOME.SERVICE_REGISTRATION": "Registration",
  "PWA_HOME.SERVICE_TRACK": "Track Service",
  "PWA_HOME.SERVICE_DASHBOARD": "Dashboard",
  "PWA_HOME.POPULAR_TITLE": "Popular Resources",
  "PWA_HOME.RES_CALL_DIRECTORY": "Call Directory",
  "PWA_HOME.NEWS_TITLE": "News & Notifications",
  "PWA_HOME.NEWS_SOURCE": "Source:",
  "PWA_HOME.NEWS_EMPTY": "No updates right now",
  "PWA_HOME.RADIO_TITLE": "Bihar Krishi Radio",
  "PWA_HOME.RADIO_STREAMING": "Radio Streaming",
  "PWA_HOME.RADIO_PAUSED": "Paused",
  "PWA_HOME.RADIO_PLAY": "Play radio",
  "PWA_HOME.RADIO_PAUSE": "Pause radio",
  "PWA_HOME.RADIO_CLOSE": "Close radio player",
};

export const hi = {
  "LOCATION_FILTER.ARIA": "स्थान के अनुसार फ़िल्टर करें",
  "LOCATION_FILTER.DISTRICT": "जिला",
  "LOCATION_FILTER.BLOCK": "प्रखंड",
  "LOCATION_FILTER.PANCHAYAT": "पंचायत",
  "LOCATION_FILTER.SELECT": "चुनें",
  "LOCATION_FILTER.SELECT_DISTRICT": "जिला चुनें",
  "LOCATION_FILTER.SELECT_BLOCK": "ब्लॉक चुनें",
  "LOCATION_FILTER.SELECT_PANCHAYAT": "पंचायत चुनें",
  // inferred, needs translator
  "LOCATION_FILTER.ALL": "सभी",
  // inferred, needs translator
  "LOCATION_FILTER.NO_OPTIONS": "कोई विकल्प नहीं",
  "FILTER_ROW.SORT_BY": "क्रमबद्ध करें",
  "FILTER_ROW.CATEGORY": "श्रेणियाँ",
  "FILTER_ROW.MIN": "न्यूनतम",
  "FILTER_ROW.MAX": "अधिकतम",
  "FILTER_ROW.DATE_FROM": "प्रारंभ तिथि",
  "FILTER_ROW.DATE_TO": "अंतिम तिथि",
  // inferred, needs translator
  "FILTER_ROW.FROM": "से",
  "FILTER_ROW.TO": "तक",
  // inferred, needs translator
  "FILTER_ROW.DATE_CLEAR": "तिथियाँ हटाएँ",
  // inferred, needs translator
  "FILTER_ROW.CLEAR_ALL": "सभी हटाएँ",
  // inferred, needs translator
  "FILTER_ROW.CLEAR_FIELD": "{{label}} हटाएँ",
  // inferred, needs translator
  "FILTER_ROW.REQUIRED_TO_APPLY": "फ़िल्टर लागू करने के लिए {{label}} चुनें",
  // inferred, needs translator
  "FILTER_ROW.DATE_BOTH_REQUIRED": "लागू करने के लिए दोनों तिथियाँ चुनें",
  "ACTION_CONFIRM_DIALOG.CANCEL": "रद्द करें",
  "ACTION_CONFIRM_DIALOG.CONFIRM": "हाँ, जारी रखें",
  "DBT_REQUIRED_DIALOG.TITLE": "लाभ प्राप्त करने के लिए अपनी डीबीटी आईडी सिंक करें।",
  "DBT_REQUIRED_DIALOG.CONFIRM": "डीबीटी आईडी दर्ज करें",
  // inferred, needs translator
  "LANGUAGE_MENU.LABEL": "भाषा",
  // inferred, needs translator
  "GLOBAL_SEARCH.PLACEHOLDER_ANYTHING": "कुछ भी खोजें…",
  // inferred, needs translator
  "GLOBAL_SEARCH.VOICE_START": "आवाज़ से खोज शुरू करें",
  // inferred, needs translator
  "GLOBAL_SEARCH.VOICE_STOP": "आवाज़ से खोज बंद करें",
  "GLOBAL_SEARCH.VOICE_PERMISSION": "माइक्रोफ़ोन की अनुमति बंद है। साइट सेटिंग्स (एड्रेस बार में लॉक आइकन) से अनुमति दें और फिर से प्रयास करें।",
  "GLOBAL_SEARCH.VOICE_NO_DEVICE": "कोई माइक्रोफ़ोन नहीं मिला। माइक्रोफ़ोन जोड़ें और फिर से प्रयास करें।",
  "GLOBAL_SEARCH.VOICE_BUSY": "माइक्रोफ़ोन किसी अन्य ऐप द्वारा उपयोग में है। उसे बंद करके फिर से प्रयास करें।",
  "GLOBAL_SEARCH.VOICE_NO_SPEECH": "आवाज़ का पता लगाने में विफल",
  "GLOBAL_SEARCH.VOICE_FAILED": "आपकी आवाज़ का विश्लेषण करने में विफल रहे।",
  // inferred, needs translator
  "PWA_BOTTOM_BAR.HOME": "होम",
  "PWA_BOTTOM_BAR.HELP": "सहायता एवं समर्थन",
  // inferred, needs translator
  "PWA_BOTTOM_BAR.SERVICES": "सभी सेवाएँ",
  // inferred, needs translator
  "PWA_BOTTOM_BAR.CHAT": "बिहार कृषि AI से बात करें",
  // inferred, needs translator
  "PWA_BOTTOM_BAR.LABEL": "ऐप नेविगेशन",
  // inferred, needs translator
  "GLOBAL_SEARCH.VOICE_PROCESSING": "आवाज़ से खोज प्रोसेस हो रही है",
  // inferred, needs translator
  "PWA_APPBAR.WELCOME_PLAIN": "स्वागत है",
  // inferred, needs translator
  "PWA_APPBAR.PROFILE_MENU": "प्रोफ़ाइल मेनू",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.CLOSE_ARIA": "खाता मेनू बंद करें",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.NAME_FALLBACK": "किसान",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.VIEW_PROFILE": "प्रोफ़ाइल देखें",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.MOBILE_LABEL": "मोबाइल नंबर:",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.LOGOUT": "लॉग आउट",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.SHARE_TITLE": "बिहार कृषि साझा करें",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.SHARE_BODY":
    "बिहार कृषि मोबाइल ऐप का लिंक किसानों, दोस्तों और परिवार के साथ साझा करें ताकि वे इसे प्ले स्टोर से डाउनलोड कर सकें।",
  // inferred, needs translator
  "PWA_ACCOUNT_DRAWER.SHARE_LINK": "लिंक साझा करें",
  // inferred, needs translator
  "PWA_LANGUAGE.TITLE": "अपनी भाषा चुनें",
  "PWA_LANGUAGE.GROUP_LABEL": "भाषा",
  // inferred, needs translator
  "PWA_LANGUAGE.NOTE_LABEL": "नोट :",
  // inferred, needs translator
  "PWA_LANGUAGE.NOTE": "आप ऊपर की पट्टी से कभी भी भाषा बदल सकते हैं।",
  "PWA_LOGIN.PAGE_TITLE": "लॉग इन",
  "PWA_APP_LOADER.TITLE": "कृषि सहायक",
  // inferred, needs translator
  "PWA_HOME.QUICK_TABS_LABEL": "त्वरित सेवाएँ",
  // inferred, needs translator
  "PWA_HOME.TAB_AGENT_SERVICE": "एजेंट सेवा",
  // inferred, needs translator
  "PWA_HOME.TAB_ADVISORIES": "परामर्श",
  // inferred, needs translator
  "PWA_HOME.TAB_ASSETS": "संसाधन",
  // inferred, needs translator
  "PWA_HOME.TAB_IMPORTANT_SERVICES": "महत्वपूर्ण सेवाएँ",
  // inferred, needs translator
  "PWA_HOME.SERVICE_REGISTRATION": "पंजीकरण",
  // inferred, needs translator
  "PWA_HOME.SERVICE_TRACK": "सेवा ट्रैक करें",
  // inferred, needs translator
  "PWA_HOME.SERVICE_DASHBOARD": "डैशबोर्ड",
  // inferred, needs translator
  "PWA_HOME.POPULAR_TITLE": "लोकप्रिय संसाधन",
  // inferred, needs translator
  "PWA_HOME.RES_CALL_DIRECTORY": "कॉल डायरेक्टरी",
  // inferred, needs translator
  "PWA_HOME.NEWS_TITLE": "समाचार और सूचनाएँ",
  // inferred, needs translator
  "PWA_HOME.NEWS_SOURCE": "स्रोत:",
  // inferred, needs translator
  "PWA_HOME.NEWS_EMPTY": "अभी कोई अपडेट नहीं है",
  "PWA_HOME.RADIO_TITLE": "बिहार कृषि रेडियो",
  // inferred, needs translator
  "PWA_HOME.RADIO_STREAMING": "रेडियो चल रहा है",
  // inferred, needs translator
  "PWA_HOME.RADIO_PAUSED": "रुका हुआ",
  // inferred, needs translator
  "PWA_HOME.RADIO_PLAY": "रेडियो चलाएँ",
  // inferred, needs translator
  "PWA_HOME.RADIO_PAUSE": "रेडियो रोकें",
  // inferred, needs translator
  "PWA_HOME.RADIO_CLOSE": "रेडियो प्लेयर बंद करें",
};
